<div [class.grid-card-rounded]="theme.theme?.config?.gridCard=='round'" [class.grid-card-shadow]="theme.theme?.config?.gridShadow=='shadow'">
    <router-outlet></router-outlet>
</div>